import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { BlockingLoadingWrapper } from 'common/blocking-loading';
import { AppLoader } from 'shared/UI/UIKit/Loader';
import type { AppProvidersProps } from './Providers.types';

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ConfigProvider
      locale={ruRU}
      theme={{
        token: {
          fontFamily: 'Inter, sans-serif',
        },
      }}
    >
      <BrowserRouter>
        <Suspense fallback={<AppLoader size="large" stretched />}>
          <BlockingLoadingWrapper>{children}</BlockingLoadingWrapper>
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  );
};
